import type { ReactNode } from "react";

/** One labelled fact on a record page; use inside a <dl>. */
export function Fact({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <dt className="text-xs font-medium text-muted-foreground">{label}</dt>
      <dd className="mt-0.5 whitespace-pre-line text-foreground">{children}</dd>
    </div>
  );
}
